// React
import React from "react";

// External libraries
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// Internal
import {getDataTestId} from "../functions/data-test-ids";

function InputCopyButton(props) {
    if (!props.Show) {
        return null;
    }

    return (
        <button type="button" className="eone-ui-input-copy" onClick={props.Copy} title="Copy to clipboard" data-testid={getDataTestId(props.DataTestId, "copy-button")}>
            <FontAwesomeIcon fixedWidth={true} icon={props.Icon}/>
        </button>
    )
}

export { InputCopyButton };